export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/environments/environment.ts